// tslint:disable-next-line: max-line-length
import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { SortModel } from '@spartacus/core';
import { BREAKPOINT, BreakpointService } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';

@Component({
  selector: 'app-sorting',
  templateUrl: './sorting.component.html',
  styleUrls: ['./sorting.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  providers: [AsyncPipe],
  standalone: false,
})
export class SortingComponent implements OnInit {
  @Input() sortOptions: SortModel[];
  @Input() selectedOption: string;
  @Input() placeholder: string;
  @Input() useSelectedOptionAsLabel = false;
  @Input() sortLabels: { [code: string]: string };
  @Input() sortWidth: string;

  @Output() sortListEvent: EventEmitter<string>;

  activeLanguage$: Observable<string> = this.languageService.getActive();
  activeLanguage = this.pipeAsync.transform(this.activeLanguage$);

  isDesktop = false;
  csDesktopWidth = this.breakpointService.getSize(BREAKPOINT.lg);

  constructor(
    private languageService: ShimanoLanguageService,
    private breakpointService: BreakpointService,
    private pipeAsync: AsyncPipe
  ) {
    this.sortListEvent = new EventEmitter<string>();
  }

  ngOnInit() {}

  sortList(sortCode: string): void {
    this.sortListEvent.emit(sortCode);
  }

  isLanguageLong(): boolean {
    return this.activeLanguage === 'es' || this.activeLanguage === 'it';
  }

  getPlacement(): string[] {
    if (this.isLanguageLong()) {
      this.isDesktop = window.innerWidth >= this.csDesktopWidth;
      if (!this.isDesktop) {
        return ['bottom', 'bottom-right'];
      }
    }
    return ['bottom-left', 'bottom', 'bottom-right'];
  }
}
